export enum ClientApiErrorCodes {
    ACCOUNT_TRANSFERRED = 410,
    RESPONSE_EMPTY = 8,
    AUTHENTICATION_FAILED = 9,
    GS_RESPONSE_EMPTY = 10,
    USER_MUST_CHANGE_PASSWORD = 11,
    INVALID_RESPONSE = 12,
    AUTHORIZATION_FAILED = 13,
    CANT_DECRYPT = 15,
    WRONG_EMAIL = 16,
    NOT_REGISTERED = 17,
    EMAIL_EXISTS = 18,
    CANT_SEND_EMAIL = 19,
    INVALID_CONSENT = 20,
    INVALID_PASSWORD_LENGTH = 21,
    USER_NOT_FOUND = 101,
    BAD_REQUEST = 400,
    NOT_FOUND = 404,
    TOO_MANY_REQUESTS = 429,
    COMMAND_NOT_FOUND = 400,
    CRITICAL = 666,
    DEPRECATED_METHOD = 667,
    HARD_STOP = 5000,
    NO_TETHER_PROGRESS = 5001,
    INVALID_TETHER_PIN = 5002,
    TETHER_TRIES_EXCEEDED = 5003,
    USER_ALREADY_EXISTS = 5004,
    TRIUMPH_CLOSED = 5005,
    ACCOUNT_TO_BE_DELETED = 5006,
    EXPIRED = 5008,
    TOO_MANY_CHARACTERS = 5009
}
